import { render, staticRenderFns } from "./CustomerBuyingHabits.vue?vue&type=template&id=e2293a5c&"
import script from "./CustomerBuyingHabits.vue?vue&type=script&lang=js&"
export * from "./CustomerBuyingHabits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports